// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import 'boxicons'
import './web_components/upload_status_icon'
import "./channels"
import { init, browserTracingIntegration } from "@sentry/browser";

const appConfig = window.AppConfig;

if (
  appConfig &&
  appConfig.environment === 'production' &&
  typeof appConfig.baseUrl !== 'undefined' &&
  typeof appConfig.sentryDsn !== 'undefined'
) {
  init({
    dsn: appConfig.sentryDsn,
    environment: appConfig.environment,
    tracesSampleRate: 1.0,
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: [appConfig.baseUrl],
  });
}
